import { Component } from "@angular/core";

@Component({
  selector: "toolbox-colors",
  templateUrl: "./colors.component.html",
  styleUrls: ["./colors.component.scss"],
})
export class ColorsComponent { }
